let isShowDICOMTag = true;

function toggleIsShowDICOMTag() {
  isShowDICOMTag = !isShowDICOMTag;
}

function setIsShowDICOMTag(state) {
  if (typeof measureName !== "boolean") {
    return;
  }
  isShowDICOMTag = state;
}

function getIsShowDICOMTag() {
  return isShowDICOMTag;
}

const ShowDICOM = {
  getIsShowDICOMTag,
  setIsShowDICOMTag,
  toggleIsShowDICOMTag
};

export default ShowDICOM;
